import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login, logout } from 'redux/action';
import { Modal, Form } from 'react-bootstrap';
import { Card, Button, Input, Dropdown, DatePicker, Row } from 'components';
import { toast } from 'react-toastify';
import { AiFillCloseCircle } from 'react-icons/ai';
import moment from 'moment';

const SubscriptionDetails = ({ _this }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(_this.subscriptionDetails);
  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      {_this.subscriptionDetails?.status == 'Cancelled' && (
        <p>Subscription has already been cancelled.</p>
      )}
      {!_this.subscriptionDetails?.enable_cancellation_by_customer_through_email && (
        <p>You are not authorized for the action.</p>
      )}
      {_this.subscriptionDetails?.status !== 'Cancelled' &&
        _this.subscriptionDetails?.enable_cancellation_by_customer_through_email && (
          <CancellationModal _this={_this} />
        )}

      <div className=" flex justify-center items-center w-24 mt-4">
        <Button
          onClick={() => {
            dispatch(logout());
            navigate('/');
          }}
        >
          Go To HSPP
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionDetails;

const CancellationModal = ({ _this }) => {
  return (
    <Modal
      style={{ zIndex: 9999 }}
      className="mt-10"
      show={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Confirm Subscription Cancellation
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="flex flex-col justify-center items-center">
        Are You sure you want to cancel the subscription?
      </Modal.Body>

      <Modal.Footer>
        <Button color="danger" onClick={() => _this.cancelSubscriptionByCustomer()}>
          Cancel Subscription
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

//test
